import { fromJS } from "immutable"

import {
    SET_TAGS_FILTER,
    SET_STORY_TAGS
} from "./../actions/index"

const initialState = fromJS({
    storyTags: null,
    tagsFilter: []
})

function storyReducer (state = initialState, action) {
    switch (action.type) {
    case SET_STORY_TAGS:
        return state.set("storyTags", action.data)
    case SET_TAGS_FILTER:
        return state.set("tagsFilter", [...action.data]) // Using the spread to create a new array
    default:
        return state
    }
}

export default storyReducer



// WEBPACK FOOTER //
// ./src/reducers/stories.js